import Navigation from "../components/Navigation";
import Footer from "../components/Footer";
import FadeIn from "../components/FadeIn";
import SEO from "../components/SEO";

export default function MatchExplainedPage() {
  return (
    <div className="min-h-screen bg-white" data-testid="match-explained-page">
      <SEO title="What is a Match?" path="/match" description="A match on HAEVN means 80%+ compatibility. Not a like. Not a swipe. Real alignment based on what you both want." />
      <Navigation />

      <section className="pt-20 pb-12 md:pt-28 md:pb-16 px-6 md:px-12">
        <div className="max-w-4xl mx-auto">
          <FadeIn>
            <h1 className="font-headline text-4xl sm:text-5xl text-haevn-navy">What is a match?</h1>
          </FadeIn>
        </div>
      </section>

      <div className="h-px bg-gradient-to-r from-transparent via-gray-200 to-transparent" />

      <section className="py-20 px-6 md:px-12 bg-[#F8F7F5]">
        <div className="max-w-4xl mx-auto">
          <FadeIn>
            <p className="text-base md:text-lg text-gray-700 font-body mb-4 leading-relaxed">
              A match means you and another person meet or exceed an 80% alignment threshold.
            </p>
            <p className="text-base md:text-lg text-gray-700 font-body leading-relaxed">
              This includes intent, preferences, and compatibility factors.
            </p>
          </FadeIn>
        </div>
      </section>

      <div className="h-px bg-gradient-to-r from-transparent via-gray-200 to-transparent" />

      <section className="py-20 px-6 md:px-12">
        <div className="max-w-4xl mx-auto">
          <FadeIn>
            <p className="text-xl md:text-2xl text-haevn-navy font-subhead leading-relaxed">
              You're not seeing everyone.
              <br />You're seeing the right people.
            </p>
          </FadeIn>
        </div>
      </section>

      <Footer />
    </div>
  );
}
